module.exports = __webpack_public_path__ + "assets/img/codelogin.766b441c.png";